import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { TreeOurNodeObj } from "./tree-our-node-obj";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export const useTreeOurNodeMachineHook = (): TreeOurNodeObj => {
  const handleCheckBoxClick = (node: OurNode) => {
    const nodeManager = getNodeManager();

    nodeManager.getMachineCheckBoxClickHandler().toggleSelected(node);
  };

  return {
    handleCheckBoxClick: handleCheckBoxClick,
  };
};
